import { JSX, useState } from 'react';
import TodoDate from '../todolist/todoDate/date'
import './noteContent.css'
import ContentBox from '../todolist/add-todo/contentBox';
import ChickenIcon from '../assets/images/icons/weathercock.png';

interface NoteContentProps {
  noteContent: string;
  noteDate: Date;
  onContentChange: (content: string) => void;
  onDateChange: (date: Date) => void;
  onFocus?: () => void;
  editMode: boolean;
};

const NoteContent = ({noteContent, noteDate, onContentChange, onDateChange, onFocus, editMode}:NoteContentProps): JSX.Element => {
    return (
      <div className={editMode? 'content-container' : 'content-container-readonly'}>
        <div className='content-menu-container'>
            <TodoDate dateFormat={'MMM dd, EEE'} date={noteDate} onTodoDateChange={onDateChange}/>
            <div className="divider"></div>
            <img className="chicken-image" src={ChickenIcon}/>
        </div>
        <div className="divider-horizontal"/>
        <ContentBox todoContent={noteContent} onContentChange={onContentChange} onFocus={onFocus}/>
      </div>
    ); 
};
  
export default NoteContent;